// import parse from 'date-fns/parse'
import format from 'date-fns/format'

// import differenceInHours from 'date-fns/difference_in_hours'
// import differenceInMinutes from 'date-fns/difference_in_minutes'
// import differenceInSeconds from 'date-fns/difference_in_seconds'

/** >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
 * This YavaScript is a helper for the Calendar page/module
 *** >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>*/

export default function() {

	window.addEventListener('DOMContentLoaded', () => {

		// for CSS purposes, the elements need to be in a particular order, with wrappers

		const $catCol = document.querySelector('#hcFilter .catCol')
		const $$catLabels = $catCol.querySelectorAll('label')
		_.each($$catLabels, $label => {
			const $div = document.createElement('div')
			$div.classList.add('checkbox')
			$label.parentNode.insertBefore($div, $label)
			$div.appendChild($label)
			const $input = $label.querySelector('input')
			$div.insertBefore($input, $label)
		})

		const $$headers = document.querySelectorAll('#events .header')
		_.each($$headers, $header => {
			const $ul = $header.nextElementSibling
			const $div = document.createElement('div')
			$div.classList.add('day-group')

			$header.parentNode.insertBefore($div, $header)
			$div.appendChild($header)
			$div.appendChild($ul)
		})
		const $eventsWrap = document.createElement('div')
		$eventsWrap.classList.add('events-wrap')
		const $$groups = document.querySelectorAll('#events .day-group')
		$$groups[0].parentNode.insertBefore($eventsWrap, $$groups[0])
		_.each($$groups, $group => {
			$eventsWrap.appendChild($group)
		})

		let then
		const $$times = document.querySelectorAll('#events .events-wrap time')
		_.each($$times, $time => {

			// create day/year wrapper
			const $div = document.createElement('div')
			$div.classList.add('day-year')
			const thenString = $time.getAttribute('datetime')
			const [year, month, day] = thenString.substr(0, 10).split('-')
			then = new Date(year, (month - 1), day)
			$div.innerHTML = `${format(then, 'MMM')} <span>${format(then, 'D')}</span>`
			$time.parentNode.insertBefore($div, $time)

			$time.innerHTML = format(then, 'MMMM D, YYYY') + '<br>' + $time.textContent

			// wrap all other elements
			const $content = document.createElement('div')
			$content.classList.add('content')
			$time.parentNode.insertBefore($content, $time)
			let $elem = $time
			let $elemToMove
			while ($elem) {
				$elemToMove = $elem
				$elem = $elem.nextElementSibling
				$content.appendChild($elemToMove)
			}

		})

		const $$navs = document.querySelectorAll('#events .event-list-nav')
		_.each($$navs, $nav => {
			const $divider = document.createElement('li')
			$divider.classList.add('divider')
			$nav.insertBefore($divider, $nav.childNodes[6])

			const $month = document.createElement('li')
			$month.classList.add('month-name')
			$month.textContent = format(then, 'MMMM')
			$nav.appendChild($month)
		})

		const $layoutWrap = document.createElement('div')
		$layoutWrap.classList.add('layout-wrap')
		const $calendar = document.querySelector('.calendar-section')
		const $filter = document.querySelector('.calendar-section > #filter')
		const $aside = document.querySelector('.calendar-section > aside')
		const $events = document.querySelector('.calendar-section > #events')

		$calendar.appendChild($layoutWrap)
		$calendar.appendChild($events)
		$layoutWrap.appendChild($aside)
		$layoutWrap.appendChild($filter)

		document.querySelector('.calendar-section').classList.add('fouc-done')

	})

}
